<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
                 
            <vs-input class="inputx" placeholder="Barkod" @keyup.enter="stokListesi()"  :ref="barkod" v-model="barkod" />        </div>
      </vx-card>
      <br/>

    </div>
<div class="vx-col w-full mb-base">
    <vs-table :data="liste" >

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Pazaryeri</vs-th>
      <vs-th  sort-key="stokkodu">Sipariş Stok Kodu</vs-th>
      <vs-th>Sipariş Stok Adı</vs-th>
      <vs-th></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
 <vs-td :data="data[indextr].program">
          {{ data[indextr].program }}
        </vs-td>
        <vs-td>
          {{ data[indextr].merchantSku }}
        </vs-td>
        <vs-td :data="data[indextr].productName">
          {{ data[indextr].productName }}
        </vs-td>
      
        <vs-td>
        <vs-button @click="activePrompt = true; kodlar(data[indextr].program,data[indextr].merchantSku);" color="success" type="filled">Kod Eşleştir</vs-button>
        </vs-td>
      </vs-tr>
     
     
    </template>

  </vs-table>
</div>

<vs-prompt title="Kod Eşleştirme" acceptText="Kod Eşleştir" cancelText="Vazgeç"
      @accept="kodEslestir"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Muhasebe Stok Kodu</span>
      <vs-input type="text" placeholder="Stok Kodu" v-model="eslesecekStokKodu" class="mt-3 w-full" />
      </div>
    </vs-prompt>

  </div>


    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      liste:[],
      eslesecekStokKodu:'',
      activePrompt:false,
      eKod:'',
      eProgram:'',
    }
  },methods: {
    kodEslestir() {
       const vm = this
      var vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {program: this.eProgram,pazaryeriKod:this.eKod,muhasebeKod:this.eslesecekStokKodu}

      soap.createClient(url, function(err, client){
      client.stokKoduEslestir(args, function(err, result){
        

      vm.veriler=JSON.parse(result.stokKoduEslestirResult)
        if (vm.veriler.response=='Ok') {
          
          vs.notify({
            title: 'Kod Eşleme',
            text: "Kod Eşleme İşlemi Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
          vm.stokListesi();
        } else {
          vs.notify({
            title: 'Kod Eşleme',
            text: "Kod Eşleme Sırasında Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }
      })
      })

    },
    kodlar(program,merchantSku) {
      this.eKod=merchantSku;
      this.eProgram=program;
    },
    stokListesi() {

      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

     
      const args = {program:'SERVIS',baslik:'stokKoduOlmayan',ARANAN:'',token:Store.state.tokenId,companyID:''}
      soap.createClient(url, function(err, client){
      client.standartSorgular(args, function(err, result){
        if (result.standartSorgularResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

       vm.veriler=JSON.parse(result.standartSorgularResult)
      // console.log(vm.veriler)
       
       vm.liste=vm.veriler
       
        
      })
     
      })


    },
    
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        
      },
      deep: true
    }
  },beforeMount(){
     this.stokListesi()
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
